const THEME_DARK = {
  argument: [253, 151, 31],
  boolean: [174, 129, 255],
  comment: [117, 113, 94],
  keyword: [249, 38, 114],
  name: [230, 219, 116],
  number: [174, 129, 255],
  plain: [128, 128, 128],
  property: [102, 217, 239],
  string: [166, 226, 46],
};

export default THEME_DARK;
